import { AfterViewInit, ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PRESETS_PERIODO_SEM_ONTEM_E_HOJE } from '../../shared/utils/periodo.utils';
import { DespesaService } from '../../services/movimento/despesa.service';
import { ContaService } from '../../services/conta/conta.service';
import { CotacaoGuardService } from '../../services/cotacao/cotacao-guard.service';
import { CotacaoService } from '../../services/cotacao/cotacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService, SortEvent } from 'primeng/api';
import { TipoDeDespesa, TIPOS_DESPESA_NAO_EXIBIR } from '../../enums/TipoDespesa.enum';
import { Moeda } from '../../enums/moeda.enum';
import { TipoTransacao } from '../../enums/TipoTransacao.enum';
import { DespesaDTO, DespesaFiltrosDTO, TotalMoedaDTO, DespesaDashboardDTO, TipoDespesaBackendDTO } from '../../models/gerenciar-contas/despesa.model';
import { ContaDTO } from '../../models/gerenciar-contas/conta.model';
import { PessoaService } from '../../services/pessoas/pessoas.service';
import { EmpresaConfigService } from '../../services/configuracoes/empresa.service';
import { EmpresaConfigDTO, MoedaDTO } from '../../models/configuracoes/empresa.model';
import { debounceTime, distinctUntilChanged, firstValueFrom, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TipoDespesaService } from '../../services/enums/tipo-despesa.service';
import { TableColumn } from '../../models/shared/table-column.model';
import { FormaPagamentoResult, DadosPagamentoDinheiro, DadosPagamentoConta, DadosPagamentoCartao, DadosPagamentoQrCode } from '../../shared/components/forma-pagamento-dialog/forma-pagamento-dialog.interfaces';
import { PessoaDTO } from '../../models/clientes/pessoa.model';
import { EntitySelectorConfig } from '../../shared/components/entity-selector/entity-selector.interfaces';
import { PeriodoFiltro } from '../../models/dashboard/periodo-filtro.model';
import { Calendar } from 'primeng/calendar';
import { PermissaoService } from '../../services/permissao/permissao.service';
import { NotaService } from '../../services/financeiro/notas.service';
import { moedasCompativeis } from '../../utils/moeda-pareamento.util';
import { toLocalISOString } from '../../shared/utils/date-utils';

@Component({
  selector: 'app-nova-despesa',
  templateUrl: './nova-despesa.component.html',
  styleUrls: ['./nova-despesa.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class NovaDespesaComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('calendario') calendario!: Calendar;

  // Opcoes do filtro de periodo (sem "Ontem e hoje")
  readonly opcoesPeriodo = PRESETS_PERIODO_SEM_ONTEM_E_HOJE;

  // Controle de abas (0 = Cadastro, 1 = Lista)
  activeTabIndex: number = 1;

  // Label dinamico do botao "Outros" (mostra a data quando selecionada via calendario)
  outrosLabel = '';

  // Controle de validacao visual
  isFormSubmitted = false;
  // String formatada do campo valor (para evitar que ngModel sobrescreva a mascara)
  montanteStr = '';

  // Objetos de traducao (seguindo padrao add-cliente)
  texts = {
    titulo: '',
    subtitulo: '',
    aba_cadastro: '',
    aba_lista: '',
    dados_do_gasto: '',
    valor_e_data: '',
    lista_de_despesas: '',
    nenhuma_despesa: '',
    ajuste_filtros: '',
    carregando: '',
    confirmacao: '',
    confirmar_exclusao: '',
    filtros_titulo: '',
    filtros_avancados: '',
    filtros_avancados_subtitulo: '',
    total_guarani: '',
    total_dolar: '',
    total_real: '',
    total_peso: '',
    nova_despesa: '',
  };

  labels = {
    descricao: '',
    tipo_de_gasto: '',
    pessoa_fornecedor: '',
    moeda: '',
    valor: '',
    data: '',
    hoje: '',
    ontem: '',
    outros: '',
    id: '',
    data_emissao: '',
    observacao: '',
    tipo_despesa: '',
    acoes: '',
    ruc: '',
    nome_fornecedor: '',
    ddi: '',
    telefone: '',
    cidade: '',
    itens_por_pagina: '',
    filtro_observacao: '',
    filtro_fornecedor: '',
    filtro_tipo_despesa: '',
    filtro_periodo: '',
    filtro_conta: '',
  };

  placeholders = {
    descricao: '',
    selecionar: '',
    buscar: '',
    valor: '',
    ruc: '',
    nome_fornecedor: '',
    telefone: '',
    filtro_observacao: '',
  };

  botoes = {
    salvar: '',
    atualizar: '',
    limpar: '',
    cancelar: '',
    adicionar: '',
    confirmar: '',
    filtrar: '',
    limpar_filtros: '',
  };

  tooltips = {
    editar: '',
    excluir: '',
    abrir_calendario: '',
    imprimir: '',
    ver_fatura: '',
    ver_transferencia: '',
  };

  private langChangeSub!: Subscription;

  // Sidebar de filtros avancados
  sidebarFiltrosVisible = false;

  // Wave dialog de exclusao
  deleteDialogVisible = false;
  deleteItemId: number | null = null;

  form: DespesaDTO = this.createEmptyForm();
  despesas: DespesaDTO[] = [];
  despesasOriginal: DespesaDTO[] = [];
  tiposDespesa: { label: string; value: string; icone?: string; cor?: string }[] = [];
  moeda: { label: string; value: Moeda; flagUrl: string }[] = [];
  contas: { label: string; value: number; flagUrl: string }[] = [];
  /** Contas completas do backend (usado para detectar conta bancaria) */
  private contasFull: any[] = [];
  /** Flag para evitar reload duplicado na auto-selecao de conta */
  private _initialLoadDone = false;
  /** Flag que sinaliza o fim do boot inicial: setada como true apos o primeiro
   *  disparo de loadDespesas/carregarTotais com filtroConta resolvido.
   *  Enquanto for false, bloqueamos dispatches com filtroConta null para evitar
   *  a chamada "sem conta" que competia com a chamada "com conta" no boot. */
  private _bootLoadComplete = false;
  pessoas: any[] = [];
  clientesList: { label: string; value: any }[] = [];
  clientes: any[] = [];
  clienteSelecionado: any = null;
  pessoaSelecionada: PessoaDTO | undefined;
  clienteSelectorConfig!: EntitySelectorConfig;
  visibleDialogCliente: boolean = false;
  origemDialogoCliente: 'formulario' | 'filtro' = 'formulario';
  dataSelecionada: string = 'hoje';
  movimento?: any
  empresa: EmpresaConfigDTO | null = null;
  first: number = 0;
  rows: number = 10;
  searchTerm: string = '';

  // Estado de ordenacao server-side (padrao movimentacao)
  lastfield: string = 'emissao';
  lastSort: string = 'asc';
  totalRecords: number = 0;
  loading: boolean = true;
  pageSizeOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];
  pessoa_id: number | null = null;
  // Configuracao de colunas visiveis
  readonly STORAGE_KEY = 'nova-despesa-visible-columns';

  columns: TableColumn[] = [
    { key: 'id', labelKey: 'nova-despesa.labels.id', visible: true, fixed: true, defaultVisible: true },
    { key: 'emissao', labelKey: 'nova-despesa.labels.data_emissao', visible: true, fixed: false, defaultVisible: true },
    { key: 'observacao', labelKey: 'nova-despesa.labels.observacao', visible: true, fixed: false, defaultVisible: true },
    { key: 'tipoDespesa', labelKey: 'nova-despesa.labels.tipo_despesa', visible: true, fixed: false, defaultVisible: true },
    { key: 'pessoa', labelKey: 'nova-despesa.labels.pessoa_fornecedor', visible: true, fixed: false, defaultVisible: true },
    { key: 'valor', labelKey: 'nova-despesa.labels.valor', visible: true, fixed: false, defaultVisible: true },
    { key: 'acoes', labelKey: 'nova-despesa.labels.acoes', visible: true, fixed: true, defaultVisible: true },
  ];

  private search$ = new Subject<string>();

  // Componente de forma de pagamento
  mostrarDialogPagamento = false;
  moedaPadraoISO: 'BRL' | 'PYG' | 'USD' | 'ARS' = 'BRL';
  /**
   * Moeda padrao da EMPRESA em codigo ISO. Propagada ao dialog para que o
   * filtro de cards seja a INTERSECAO entre MOEDAS_COMPATIVEIS da moeda do
   * registro (moedaPadraoISO) e MOEDAS_COMPATIVEIS da moeda da empresa.
   * Ex.: registro em Guarani + empresa em Real -> oculta o card PESO.
   * Atualizada em findEmpresa() e em abrirDialogPagamento() (defesa em profundidade).
   */
  moedaEmpresaISO: 'BRL' | 'PYG' | 'USD' | 'ARS' | undefined;
  contasFormatadas: { label: string; value: any }[] = [];
  processandoDespesa = false;
  submitting = false;

  // Cotacoes (USD como base)
  cotUSD = 1;
  cotPYG = 7180;
  cotBRL = 5.47;
  /** Cotacao Peso Argentino em Guaranis (1 ARS = N PYG). 0 = peso desabilitado. */
  cotPesoGuarani = 0;
  /** Cotacao direta BRL->PYG (1 BRL = N PYG). 0 = triangulacao via USD. */
  cotRealGuarani = 0;

  // === Filtros server-side (alinhamento-despesas) ===
  filtroObservacao: string = '';
  filtroPessoaId: number | null = null;
  filtroPessoaSelecionada: PessoaDTO | undefined;
  filtroPessoaSelectorConfig!: EntitySelectorConfig;
  filtroTipoDespesa: string | null = null;
  filtroDataInicio: Date | null = null;
  filtroDataFim: Date | null = null;
  filtroConta: number | null = null;
  // Texto exibido no botao do periodo-filtro
  periodoDespesaTexto: string = '';
  filtrosAtivos: boolean = false;

  // Tipos de despesa para dropdown de filtro (sem os nao exibiveis)
  tiposDespesaFiltro: { label: string; value: string; icone?: string; cor?: string }[] = [];

  // Mapa de tipos de despesa com icone e cor (carregado do backend)
  tipoDespesaMap: Map<string, { icone: string; cor: string }> = new Map();

  // Totais por moeda
  totais: TotalMoedaDTO = {
    valorTotalEmGuarani: 0,
    valorTotalEmReal: 0,
    valorTotalEmDolar: 0,
  };
  loadingTotais: boolean = false;

  // Filtro por moeda (clique nos cards de totais)
  filtroMoedaSelecionada: string | null = null;

  /** Retorna true quando a conta selecionada no filtro é uma conta bancária (tipoConta === 'BANCO'). */
  get contaBancariaAtiva(): boolean {
    if (this.filtroConta == null) return false;
    const conta = this.contasFull.find(c => c.id === this.filtroConta);
    const tipo = conta?.tipoConta;
    const tipoStr = typeof tipo === 'object' ? (tipo as any)?.enum : tipo;
    return tipoStr === 'BANCO';
  }

  /** Retorna o enum da moeda da conta selecionada (GUARANI, DOLAR, REAL) ou null. */
  get moedaContaSelecionada(): string | null {
    if (this.filtroConta == null) return null;
    const conta = this.contasFull.find(c => c.id === this.filtroConta);
    return conta?.moeda?.enum || null;
  }

  /**
   * Conjunto de moedas permitidas para a empresa logada, baseado na
   * matriz de pareamento (moedasCompativeis). Usado para filtrar quais
   * cards de Total exibir.
   *
   * Fallback: enquanto a empresa nao carregou, retorna o conjunto completo
   * (todas as 4 moedas) para evitar placeholder vazio. O filtro fica
   * estavel apos a primeira resposta de getSessao().
   */
  get moedasPermitidas(): Set<string> {
    const moedaEmp = this.empresa?.moeda
      ? this.asEnumString(this.empresa.moeda)
      : null;
    if (!moedaEmp) return new Set(['GUARANI', 'DOLAR', 'REAL', 'PESO']);
    return new Set(moedasCompativeis(moedaEmp as any));
  }


  // Impressao PDF
  imprimindoId: number | null = null;
  mostrarDialogoImpressao = false;
  opcaoImpressao = 'A4';
  private idParaImprimir: number | null = null;
  private tipoParaImprimir: string = 'MOVIMENTO';

  constructor(
    private despesaService: DespesaService,
    private contaService: ContaService,
    private cotacaoService: CotacaoService,
    private cotacaoGuard: CotacaoGuardService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
    private pessoaService: PessoaService,
    private translate: TranslateService,
    private empresaService: EmpresaConfigService,
    private cdr: ChangeDetectorRef,
    private tipoDespesaService: TipoDespesaService,
    private permissaoService: PermissaoService,
    private notaService: NotaService,
  ) { }

  ngAfterViewInit(): void {
    // Desabilitar tabindex do input do calendario para evitar foco acidental
    if (this.calendario?.inputfieldViewChild?.nativeElement) {
      this.calendario.inputfieldViewChild.nativeElement.setAttribute('tabindex', '-1');
    }
  }

  ngOnInit() {
    // showAddInDropdown somente se o usuario tiver permissao de cadastrar clientes
    const podeAdicionarCliente = this.permissaoService.temPermissao('cliente');

    this.clienteSelectorConfig = {
      categoryFilter: 'categoriaCliente=true',
      placeholder: this.translate.instant('nova-despesa.placeholders.selecionar') || this.placeholders.selecionar,
      showAddButton: false,
      showAddInDropdown: podeAdicionarCliente,
      dialogTitle: this.translate.instant('nova-despesa.texts.selecionar_pessoa') || this.texts.titulo,
      dialogIcon: 'pi pi-users',
    };

    this.filtroPessoaSelectorConfig = {
      categoryFilter: 'categoriaCliente=true',
      placeholder: this.translate.instant('nova-despesa.placeholders.selecionar') || this.placeholders.selecionar,
      showAddButton: false,
      showAddInDropdown: podeAdicionarCliente,
      dialogTitle: this.translate.instant('nova-despesa.texts.selecionar_pessoa') || this.texts.titulo,
      dialogIcon: 'pi pi-users',
    };

    this.loadColumnPreferences();
    this.loadContas();
    this.lerFiltrosDashboard();
    this.carregarClientes();
    this.buildMoedaOptions();
    // Pre-selecao defensiva da primeira moeda enquanto findEmpresa() nao
    // resolve. O `findEmpresa.next` (linhas ~699-705) sobrepoe esta selecao
    // pela moeda padrao da empresa quando ela chegar. Se a empresa estiver
    // disponivel sincronamente (cache), a etapa de fallback nao se aplica.
    if (!this.form.moeda && this.moeda.length > 0) {
      this.form.moeda = this.moeda[0];
    }
    this.definirDataHoje();
    this.findEmpresa();
    this.setupSearchDebounce();

    // Abrir aba de cadastro se vier do menu de atalhos com aba=cadastro
    if (this.route.snapshot.queryParams['aba'] === 'cadastro') {
      this.activeTabIndex = 0;
    }

    // Carregar mapa de tipos primeiro e so entao montar o dropdown com icones
    this.loadTranslations();
    this.loadTiposDespesaMap(() => {
      // Apos o mapa ser populado, re-enriquecer o dropdown com icones/cores
      this.enriquecerDropdownTiposDespesa();
      this._initialLoadDone = true;
      // Tenta auto-selecionar conta DINHEIRO caso findEmpresa + loadContas ainda nao tenham retornado.
      // Se ja retornaram (filtroConta != null), autoSelecionarContaDinheiro retorna imediatamente
      // por causa do guard `if (filtroConta != null) return`, entao disparamos a carga diretamente.
      if (this.filtroConta != null) {
        this.loadDespesas(0, this.rows);
        this.carregarTotais();
      } else {
        this.autoSelecionarContaDinheiro();
      }

      // Se veio editId via queryParams (navegacao da lista de movimentos), carregar despesa para edicao
      const editId = this.route.snapshot.queryParams['editId'];
      if (editId) {
        this.carregarDespesaParaEdicao(+editId);
      }

      // Pre-selecionar pessoa via queryParam (navegacao de acoes rapidas de clientes)
      const pessoaIdParam = this.route.snapshot.queryParams['pessoaId'];
      if (pessoaIdParam && !editId) {
        this.pessoaService.get(`/pessoas/${pessoaIdParam}`).subscribe(
          (pessoa: any) => {
            const pessoaDTO = pessoa as PessoaDTO;
            // Preenche formulario de cadastro
            this.pessoaSelecionada = pessoaDTO;
            this.form.pessoa_id = pessoaDTO.id;
            // Preenche filtro da aba Lista e aplica
            this.filtroPessoaSelecionada = pessoaDTO;
            this.filtroPessoaId = pessoaDTO.id ?? null;
            this.aplicarFiltros();
          }
        );
      }
    });

    // Atualiza traducoes quando idioma muda
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.buildMoedaOptions();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
    this.search$.complete();
  }

  /** Lê filtros passados pelo dashboard via queryParams e os aplica automaticamente.
   *  Quando não há parâmetros, inicializa com o mês atual como período padrão. */
  private lerFiltrosDashboard(): void {
    const params = this.route.snapshot.queryParams;
    const dataInicial = params['dataInicial'];
    const dataFinal = params['dataFinal'];
    const contaId = params['contaId'];

    if (dataInicial) {
      this.filtroDataInicio = this.parsarDataDashboard(dataInicial);
    }
    if (dataFinal) {
      this.filtroDataFim = this.parsarDataDashboard(dataFinal);
    }
    if (contaId) {
      const id = parseInt(contaId, 10);
      if (!isNaN(id)) {
        this.filtroConta = id;
      }
    }

    if (this.filtroDataInicio || this.filtroDataFim || this.filtroConta !== null) {
      this.filtrosAtivos = true;
      // Veio do dashboard com filtros: abrir diretamente na aba de lista
      this.activeTabIndex = 1;
    } else {
      // Sem parâmetros do dashboard: aplicar período padrão "Mostrar todos"
      // (showAll), equivalente ao valorPadrao='showAll' do app-periodo-filtro.
      // Intervalo fixo 01/01/2000 00:00 -> 31/12/3000 23:59 (alinhado ao mobile).
      this.filtroDataInicio = new Date(2000, 0, 1, 0, 0, 0);
      this.filtroDataFim = new Date(3000, 11, 31, 23, 59, 59);
      this.filtrosAtivos = true;
    }
  }

  /**
   * Converte string no formato dd/MM/yyyyTHH:mm (enviado pelo dashboard)
   * para objeto Date que os filtros da tela esperam.
   */
  private parsarDataDashboard(valor: string): Date | null {
    try {
      // Formato esperado: dd/MM/yyyyTHH:mm
      const [datePart, timePart] = valor.split('T');
      if (!datePart) return null;
      const [dia, mes, ano] = datePart.split('/').map(Number);
      const [hora, minuto] = (timePart || '00:00').split(':').map(Number);
      const d = new Date(ano, mes - 1, dia, hora || 0, minuto || 0);
      return isNaN(d.getTime()) ? null : d;
    } catch {
      return null;
    }
  }


  private loadTranslations(): void {
    const isEdicao = !!this.form.id;
    const isListaAtiva = this.activeTabIndex === 1;

    this.texts = {
      titulo: this.translate.instant(
        isListaAtiva ? 'nova-despesa.texts.titulo_nova' : isEdicao ? 'nova-despesa.texts.titulo_editar' : 'nova-despesa.texts.titulo_nova'
      ),
      subtitulo: this.translate.instant(
        isListaAtiva
          ? 'nova-despesa.texts.subtitulo_lista'
          : isEdicao
          ? 'nova-despesa.texts.subtitulo_editar'
          : 'nova-despesa.texts.subtitulo_nova'
      ),
      aba_cadastro: this.translate.instant('nova-despesa.texts.aba_cadastro'),
      aba_lista: this.translate.instant('nova-despesa.texts.aba_lista'),
      dados_do_gasto: this.translate.instant('nova-despesa.texts.dados_do_gasto'),
      valor_e_data: this.translate.instant('nova-despesa.texts.valor_e_data'),
      lista_de_despesas: this.translate.instant('nova-despesa.texts.lista_de_despesas'),
      nenhuma_despesa: this.translate.instant('nova-despesa.texts.nenhuma_despesa'),
      ajuste_filtros: this.translate.instant('nova-despesa.texts.ajuste_filtros'),
      carregando: this.translate.instant('nova-despesa.texts.carregando'),
      confirmacao: this.translate.instant('common.confirmacao'),
      confirmar_exclusao: this.translate.instant('nova-despesa.mensagens.confirmar_exclusao'),
      filtros_titulo: this.translate.instant('nova-despesa.filtros.titulo'),
      filtros_avancados: this.translate.instant('nova-despesa.filtros.avancados'),
      filtros_avancados_subtitulo: this.translate.instant('nova-despesa.filtros.avancados_subtitulo'),
      total_guarani: this.translate.instant('nova-despesa.totais.guarani'),
      total_dolar: this.translate.instant('nova-despesa.totais.dolar'),
      total_real: this.translate.instant('nova-despesa.totais.real'),
      total_peso: this.translate.instant('nova-despesa.totais.peso'),
      nova_despesa: this.translate.instant('nova-despesa.texts.nova_despesa'),
    };

    this.labels = {
      descricao: this.translate.instant('nova-despesa.labels.descricao'),
      tipo_de_gasto: this.translate.instant('nova-despesa.labels.tipo_de_gasto'),
      pessoa_fornecedor: this.translate.instant('nova-despesa.labels.pessoa_fornecedor'),
      moeda: this.translate.instant('nova-despesa.labels.moeda'),
      valor: this.translate.instant('nova-despesa.labels.valor'),
      data: this.translate.instant('nova-despesa.labels.data'),
      hoje: this.translate.instant('nova-despesa.labels.hoje'),
      ontem: this.translate.instant('nova-despesa.labels.ontem'),
      outros: this.translate.instant('nova-despesa.labels.outros'),
      id: this.translate.instant('nova-despesa.labels.id'),
      data_emissao: this.translate.instant('nova-despesa.labels.data_emissao'),
      observacao: this.translate.instant('nova-despesa.labels.observacao'),
      tipo_despesa: this.translate.instant('nova-despesa.labels.tipo_despesa'),
      acoes: this.translate.instant('nova-despesa.labels.acoes'),
      ruc: this.translate.instant('nova-despesa.labels.ruc'),
      nome_fornecedor: this.translate.instant('nova-despesa.labels.nome_fornecedor'),
      ddi: this.translate.instant('nova-despesa.labels.ddi'),
      telefone: this.translate.instant('nova-despesa.labels.telefone'),
      cidade: this.translate.instant('nova-despesa.labels.cidade'),
      itens_por_pagina: this.translate.instant('nova-despesa.labels.itens_por_pagina'),
      filtro_observacao: this.translate.instant('nova-despesa.filtros.observacao'),
      filtro_fornecedor: this.translate.instant('nova-despesa.filtros.fornecedor'),
      filtro_tipo_despesa: this.translate.instant('nova-despesa.filtros.tipo_despesa'),
      filtro_periodo: this.translate.instant('nova-despesa.filtros.periodo'),
      filtro_conta: this.translate.instant('nova-despesa.filtros.conta'),
    };

    // Atualizar label do botao "Outros" conforme estado atual
    if (this.dataSelecionada === 'outros' && this.form.emissao) {
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    } else {
      this.outrosLabel = this.labels.outros;
    }

    this.placeholders = {
      descricao: this.translate.instant('nova-despesa.placeholders.descricao'),
      selecionar: this.translate.instant('nova-despesa.placeholders.selecionar'),
      buscar: this.translate.instant('nova-despesa.placeholders.buscar'),
      valor: this.translate.instant('nova-despesa.placeholders.valor'),
      ruc: this.translate.instant('nova-despesa.placeholders.ruc'),
      nome_fornecedor: this.translate.instant('nova-despesa.placeholders.nome_fornecedor'),
      telefone: this.translate.instant('nova-despesa.placeholders.telefone'),
      filtro_observacao: this.translate.instant('nova-despesa.filtros.placeholder_observacao'),
    };

    this.botoes = {
      salvar: this.translate.instant('nova-despesa.botoes.salvar'),
      atualizar: this.translate.instant('nova-despesa.botoes.atualizar'),
      limpar: this.translate.instant('nova-despesa.botoes.limpar'),
      cancelar: this.translate.instant('nova-despesa.botoes.cancelar'),
      adicionar: this.translate.instant('nova-despesa.botoes.adicionar'),
      confirmar: this.translate.instant('nova-despesa.botoes.confirmar'),
      filtrar: this.translate.instant('nova-despesa.filtros.aplicar'),
      limpar_filtros: this.translate.instant('nova-despesa.filtros.limpar'),
    };

    this.tooltips = {
      editar: this.translate.instant('nova-despesa.tooltips.editar'),
      excluir: this.translate.instant('nova-despesa.tooltips.excluir'),
      abrir_calendario: this.translate.instant('nova-despesa.tooltips.abrir_calendario'),
      imprimir: this.translate.instant('nova-despesa.tooltips.imprimir'),
      ver_fatura: this.translate.instant('nova-despesa.tooltips.ver_fatura'),
      ver_transferencia: this.translate.instant('nova-despesa.tooltips.ver_transferencia'),
    };

    // Atualiza labels do dropdown de tipos de despesa com i18n
    // Filtrar tipos com exibir=false
    const valorSelecionado = this.form.tipoDespesa;
    this.tiposDespesa = Object.values(TipoDeDespesa)
      .filter(v => !TIPOS_DESPESA_NAO_EXIBIR.includes(v))
      .map((value) => ({
        label: this.translate.instant(`enums.tipo_despesa.${value}`),
        value: value as string,
        icone: this.tipoDespesaMap.get(value)?.icone || '',
        cor: this.tipoDespesaMap.get(value)?.cor || '',
      }));
    this.form.tipoDespesa = valorSelecionado;

    // Atualiza dropdown de filtro de tipos de despesa
    this.tiposDespesaFiltro = [...this.tiposDespesa];
  }

  /** Verifica se uma coluna esta visivel */
  isColumnVisible(key: string): boolean {
    const col = this.columns.find(c => c.key === key);
    return col ? col.visible : true;
  }

  /** Quantidade de colunas visiveis (para colspan) */
  get visibleColumnCount(): number {
    return this.columns.filter(c => c.visible).length;
  }

  /** Handler para mudanca de colunas vindas do ColumnSelector */
  onColumnsChange(columns: TableColumn[]): void {
    this.columns = [...columns];
  }

  /** Carrega preferencias de colunas do localStorage */
  private loadColumnPreferences(): void {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const visibleKeys = JSON.parse(stored) as string[];
        this.columns.forEach(col => {
          if (!col.fixed) {
            col.visible = visibleKeys.includes(col.key);
          }
        });
      }
    } catch (e) {
      console.warn('Erro ao carregar preferencias de colunas:', e);
    }
  }

  getDropItems(enumType: any): { label: string; value: any }[] {
    return Object.values(enumType).map((item) => ({
      label: String(item).toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value: item,
    }));
  }

  private buildMoedaOptions(): void {
    const permitidas = this.moedasPermitidas;
    // Edge case: ao editar despesa em moeda agora bloqueada (legacy),
    // manter a moeda atual visivel para nao "sumir" o valor selecionado.
    // No fluxo de cadastro novo, form.moeda eh undefined, entao
    // moedaAtual = null e o filtro fica estritamente nas permitidas.
    const moedaAtual = this.form?.moeda
      ? this.asEnumString((this.form.moeda as any).value ?? this.form.moeda)
      : null;

    this.moeda = Object.values(Moeda)
      .filter(m => {
        const codigo = this.asEnumString(m);
        return permitidas.has(codigo) || codigo === moedaAtual;
      })
      .map(moeda => ({
        label: this.translate.instant(`enums.moeda.${moeda.toLowerCase()}`),
        value: moeda,
        flagUrl: this.getFlagUrl(moeda),
      }));
  }

  getFlagUrl(moeda: any): string {
    const moedaStr = this.asEnumString(moeda);
    switch (moedaStr) {
      case 'GUARANI': return 'assets/images/paraguay-flag.jpg';
      case 'REAL': return 'assets/images/br-flag.svg';
      case 'DOLAR': return 'assets/images/usa-flag.svg';
      case 'PESO': return 'assets/images/argentina-flag.svg';
      default: return '';
    }
  }

  /** Carrega tipos de despesa do backend para obter icone e cor.
   *  O callback onComplete e chamado ao finalizar (com ou sem erro),
   *  garantindo que loadDespesas so execute apos o mapa estar populado.
   */
  loadTiposDespesaMap(onComplete?: () => void): void {
    this.tipoDespesaService.get<any>('/enums/tipoDespesa', {
      size: 50,
      sort: 'nome,asc',
    }).subscribe({
      next: (response: any) => {
        const tipos = Array.isArray(response) ? response : response?.content || [];
        tipos.forEach((tipo: any) => {
          // Indexar pelo campo "enum" (nome da constante, ex: "ENERGIA_ELETRICA")
          // que e o valor retornado pelo endpoint de filtros (DespesaDashboardDTO)
          const chave = tipo.enum || tipo.nome;
          if (chave) {
            this.tipoDespesaMap.set(chave, {
              icone: tipo.icone || '',
              cor: tipo.cor || '',
            });
          }
        });
        this.enriquecerDropdownTiposDespesa();
        onComplete?.();
      },
      error: () => {
        // Silencioso - tabela funciona sem icones
        onComplete?.();
      },
    });
  }

  /** Enriquece o dropdown de tipos de despesa com icone e cor do mapa */
  enriquecerDropdownTiposDespesa(): void {
    if (this.tipoDespesaMap.size === 0) return;
    this.tiposDespesa = this.tiposDespesa.map(tipo => ({
      ...tipo,
      icone: this.tipoDespesaMap.get(tipo.value)?.icone || '',
      cor: this.tipoDespesaMap.get(tipo.value)?.cor || '',
    }));
    this.tiposDespesaFiltro = [...this.tiposDespesa];
  }


  findEmpresa() {
    this.empresaService.getById('/configuracaoEmpresa/sessao').subscribe({
      next: (response) => {
        this.empresa = response;
        // Re-monta dropdown de moeda agora que `moedasPermitidas` reflete a
        // moeda padrao da empresa (sem fallback para todas as 4).
        this.buildMoedaOptions();
        // Setar moeda padrao ISO para o componente de forma de pagamento
        const moeda = this.empresa?.moeda as MoedaDTO | undefined;
        if (moeda) {
          const codigoOperacao =
            (moeda as any)?.codigoOperacao ??
            ((moeda as any)?.enum === 'REAL' ? 'BRL' : (moeda as any)?.enum === 'DOLAR' ? 'USD' : (moeda as any)?.enum === 'PESO' ? 'ARS' : 'PYG');
          this.moedaPadraoISO = (codigoOperacao as 'BRL' | 'PYG' | 'USD' | 'ARS');
          // Guardar tambem a moeda da empresa em ISO (usada como segundo
          // filtro nos cards do dialog de pagamento — vide abrirDialogPagamento).
          this.moedaEmpresaISO = this.moedaPadraoISO;
        }
        // Sincronizar dropdown de moeda com a moeda padrao da empresa
        // Apenas quando nao ha despesa em edicao, para nao sobrescrever a moeda do registro carregado
        if (this.empresa?.moeda && !this.form.id) {
          const moedaEmpresaEnum = this.asEnumString(this.empresa.moeda);
          const moedaOpcao = this.moeda.find(m => this.asEnumString(m.value) === moedaEmpresaEnum);
          if (moedaOpcao) {
            this.form.moeda = moedaOpcao;
          }
        }
        // Carregar cotacoes para multi-moeda
        this.carregarCotacoes();

        // Auto-selecionar conta DINHEIRO da moeda padrao (igualar comportamento do mobile)
        this.autoSelecionarContaDinheiro();
      },
      error: (error) => {
        console.error("Erro ao buscar empresa:", error);
      }
    });
  }

  /**
   * Auto-seleciona a conta tipo DINHEIRO da moeda padrao da empresa,
   * igualando o comportamento do mobile.
   */
  private autoSelecionarContaDinheiro(): void {
    if (this.filtroConta != null) return;
    if (!this.contasFull || this.contasFull.length === 0) return;
    if (!this.empresa?.moeda) return;

    const moedaPadraoEnum = this.asEnumString(this.empresa.moeda);

    const contaDinheiro = this.contasFull.find(c => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo === 'DINHEIRO' && moedaConta === moedaPadraoEnum;
    });

    if (contaDinheiro?.id) {
      this.filtroConta = contaDinheiro.id;
      this.filtroMoedaSelecionada = moedaPadraoEnum;
      this.filtrosAtivos = true;

      if (this._initialLoadDone) {
        this.loadDespesas(0, this.rows);
        this.carregarTotais();
      }
    }
  }

  carregarCotacoes(): void {
    this.cotacaoService.get('/cotacao/ultimaCotacao').subscribe({
      next: (res: any) => {
        if (res) {
          this.cotPYG = res.dolarGuarani || 7180;
          this.cotBRL = res.dolarReal || 5.47;
          // pesoGuarani e opcional; sem valor, coluna peso permanece oculta
          this.cotPesoGuarani = res.pesoGuarani || 0;
          // realGuarani: cotacao direta BRL->PYG; 0 = fallback triangulacao
          this.cotRealGuarani = res.realGuarani || 0;
        }
      },
      error: () => {
        // Mantem valores padrao
      }
    });
  }

  carregarClientes(): void {
    this.pessoaService.get('/pessoas/buscar?categoriaCliente=true').subscribe((res) => {
      this.clientes = res.content.map((c: any) => ({ id: c.id, nome: c.nome, fantasia: c.fantasia, email: c.email, ruc: c.ruc }));
    });
  }

  get clientesComAdicionar(): any[] {
    const clientesNormais = this.clientes.map(cliente => ({
      ...cliente,
      id: cliente.id
    }));

    const resultado = [
      ...clientesNormais,
      {
        id: -1,
        nome: 'adicionar',
        isAddButton: true
      }
    ];
    return resultado;
  }

  onRowsPerPageChange() {
    this.first = 0;
    this.loadDespesas(0, this.rows);
  }

  selecionarData(tipo: string): void {
    this.dataSelecionada = tipo;

    const hoje = new Date();

    switch (tipo) {
      case 'hoje':
        this.form.emissao = new Date();
        // Resetar label do botao "Outros" para o texto original
        this.outrosLabel = this.labels.outros;
        break;
      case 'ontem':
        const ontem = new Date(hoje);
        ontem.setDate(hoje.getDate() - 1);
        this.form.emissao = ontem;
        // Resetar label do botao "Outros" para o texto original
        this.outrosLabel = this.labels.outros;
        break;
      case 'outros':
        if (!this.form.emissao) {
          this.form.emissao = new Date();
        }
        break;
    }

    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
    }
  }

  abrirCalendario(): void {
    this.dataSelecionada = 'outros';
    setTimeout(() => {
      if (this.calendario) {
        const inputEl = this.calendario.inputfieldViewChild?.nativeElement;
        if (inputEl) {
          // Temporariamente habilitar o input para receber foco
          inputEl.removeAttribute('tabindex');
          inputEl.style.pointerEvents = 'auto';
          inputEl.focus();
          inputEl.click();
          // Voltar a desabilitar após abrir
          setTimeout(() => {
            inputEl.setAttribute('tabindex', '-1');
            inputEl.style.pointerEvents = 'none';
          }, 100);
        }
      }
    }, 0);
  }

  onDataSelecionada(): void {
    if (this.form.emissao) {
      this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
      // Atualizar label do botao "Outros" com a data selecionada
      this.outrosLabel = this.formatarDataParaExibicao(this.form.emissao);
    }
  }

  onDataChange() {
    if (this.dataSelecionada === 'hoje') {
      this.form.emissao = new Date();
    } else if (this.dataSelecionada === 'ontem') {
      const ontem = new Date();
      ontem.setDate(ontem.getDate() - 1);
      this.form.emissao = ontem;
    } else {
      this.form.emissao = undefined;
    }
  }

  private definirDataHoje(): void {
    this.form.emissao = new Date();
    this.form.emissao = this.formatarDataParaAPI(this.form.emissao);
  }

  private formatarDataParaAPI(data: Date | string): Date {
    const d = data instanceof Date ? data : new Date(data);
    const agora = new Date();
    return new Date(
      d.getFullYear(), d.getMonth(), d.getDate(),
      agora.getHours(), agora.getMinutes(), agora.getSeconds()
    );
  }

  private formatarDataParaExibicao(data: Date | string): string {
    const d = data instanceof Date ? data : new Date(data);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  abrirDialogoCliente(): void {
    this.origemDialogoCliente = 'formulario';
    this.visibleDialogCliente = true;
    this.cdr.detectChanges();
  }

  abrirDialogoClienteFiltro(): void {
    this.origemDialogoCliente = 'filtro';
    this.visibleDialogCliente = true;
    this.cdr.detectChanges();
  }

  /** Handler: fornecedor novo cadastrado via PessoaAdicionarDialogComponent */
  onFornecedorCriado(pessoa: PessoaDTO): void {
    this.clientes.push({
      id: pessoa.id,
      nome: pessoa.nome,
      fantasia: (pessoa as any).fantasia,
      email: (pessoa as any).email,
      ruc: (pessoa as any).ruc
    });
    if (this.origemDialogoCliente === 'filtro') {
      this.filtroPessoaSelecionada = pessoa;
      this.filtroPessoaId = pessoa?.id ?? null;
    } else {
      this.pessoaSelecionada = pessoa;
      this.form.pessoa_id = pessoa.id;
    }
    this.cdr.detectChanges();
  }

  /** Handler: fornecedor ja existente encontrado via RUC no PessoaAdicionarDialogComponent */
  onFornecedorVinculado(pessoa: PessoaDTO): void {
    if (this.origemDialogoCliente === 'filtro') {
      this.filtroPessoaSelecionada = pessoa;
      this.filtroPessoaId = pessoa?.id ?? null;
    } else {
      this.pessoaSelecionada = pessoa;
      this.form.pessoa_id = pessoa.id;
    }
    this.cdr.detectChanges();
  }

  onClienteChange(event: any): void {
    if (event.value === -1) {
      this.abrirDialogoCliente();
      this.form.pessoa_id = null;
      this.clienteSelecionado = null;
      return;
    }
  }

  onPessoaSelecionada(pessoa: PessoaDTO): void {
    this.pessoaSelecionada = pessoa;
    this.form.pessoa_id = pessoa?.id ?? null;
  }

  onFiltroPessoaFiltroSelecionada(pessoa: PessoaDTO): void {
    this.filtroPessoaSelecionada = pessoa;
    this.filtroPessoaId = pessoa?.id ?? null;
  }

  onFiltroPessoaFiltroLimpa(): void {
    this.filtroPessoaSelecionada = undefined;
    this.filtroPessoaId = null;
  }

  private getClienteLabel(cliente: any): string {
    return cliente?.nome || cliente?.nomeCompleto || cliente?.razaoSocial || '';
  }

  loadContas() {
    this.contaService.get('/conta').subscribe((response) => {
      this.contasFull = response.content;
      // Filtra contas visiveis no dropdown pelas moedas permitidas conforme
      // moeda padrao da empresa (regra de pareamento). Mantem `contasFull`
      // completo para preservar lookups por id (moedaContaSelecionada,
      // autoSelecionarContaDinheiro) e `contasFormatadas` para o formulario de
      // cadastro.
      const permitidas = this.moedasPermitidas;
      const contasVisiveis = response.content.filter((conta: ContaDTO) =>
        permitidas.has(this.asEnumString((conta as any).moeda)),
      );
      this.contas = contasVisiveis.map((conta: ContaDTO) => ({
        label: (conta as any).numeroConta == 0 ? `${conta.tituloDaConta} - EFETIVO` : conta.tituloDaConta,
        value: conta.id!,
        flagUrl: this.getFlagUrl((conta as any).moeda),
      }));

      // Ordenar: conta DINHEIRO da moeda padrao da empresa aparece primeiro
      if (this.empresa?.moeda) {
        const moedaPadrao = this.asEnumString(this.empresa.moeda);
        this.contas.sort((a, b) => {
          const contaA = this.contasFull.find(c => c.id === a.value);
          const contaB = this.contasFull.find(c => c.id === b.value);
          const isTopA = contaA && this.asEnumString(contaA.tipoConta) === 'DINHEIRO' && this.asEnumString(contaA.moeda) === moedaPadrao ? 1 : 0;
          const isTopB = contaB && this.asEnumString(contaB.tipoConta) === 'DINHEIRO' && this.asEnumString(contaB.moeda) === moedaPadrao ? 1 : 0;
          return isTopB - isTopA;
        });
      }

      // Formato para o componente de forma de pagamento (com objeto completo)
      this.contasFormatadas = response.content
        .filter((conta: any) => conta.tipoConta === 'BANCO' || conta.tipoConta?.enum === 'BANCO')
        .map((conta: any) => ({
          label: conta.tituloDaConta,
          value: conta,
        }));

      // Auto-selecionar conta DINHEIRO da moeda padrao (igualar comportamento do mobile)
      this.autoSelecionarContaDinheiro();
    });
  }

  loadDespesas(page: number, size: number) {
    // Guard de boot: durante a inicializacao, nao disparar busca sem conta.
    // autoSelecionarContaDinheiro resolve filtroConta assim que findEmpresa + loadContas
    // retornam; ate la, qualquer chamada com filtroConta=null seria uma requisicao
    // "sem conta" que o backend retornaria todas as despesas e seria imediatamente
    // substituida pela busca filtrada por conta. Apos o primeiro load com conta,
    // o flag _bootLoadComplete libera o fluxo normal (usuario pode legitimamente
    // limpar o filtro de conta depois).
    if (!this._bootLoadComplete && this.filtroConta == null) {
      return;
    }
    if (this.filtroConta != null) {
      this._bootLoadComplete = true;
    }

    this.loading = true;

    // Se filtros estao ativos, usar endpoint com filtros
    if (this.filtrosAtivos) {
      this.loadDespesasComFiltros(page, size);
      return;
    }

    const endpoint = '/movimento/tipoTransacao';
    const params: any = {
      tipoTransacao: 'DESPESA',
      page: page.toString(),
      size: size.toString(),
      sort: `${this.lastfield},${this.lastSort}`
    };

    this.despesaService.get(endpoint, params).subscribe({
      next: (response) => {
        if (response && response.content) {
          // Normalizar tipoDespesa: a API pode retornar string enum ou objeto
          // O template acessa despesa.tipoDespesa?.icone e ?.cor
          this.despesasOriginal = response.content.map((d: any) => ({
            ...d,
            tipoDespesa: d.tipoDespesa
              ? (typeof d.tipoDespesa === 'object'
                ? { ...d.tipoDespesa, icone: d.tipoDespesa.icone || this.tipoDespesaMap.get(d.tipoDespesa.nome)?.icone || '', cor: d.tipoDespesa.cor || this.tipoDespesaMap.get(d.tipoDespesa.nome)?.cor || '' }
                : { nome: d.tipoDespesa, icone: this.tipoDespesaMap.get(d.tipoDespesa)?.icone || '', cor: this.tipoDespesaMap.get(d.tipoDespesa)?.cor || '' })
              : undefined,
          }));
          this.despesas = [...this.despesasOriginal];
          this.totalRecords = response.totalElements || response.content.length;
        } else {
          this.despesasOriginal = [];
          this.despesas = [];
          this.totalRecords = 0;
        }

        // Reaplicar filtros locais (busca textual + moeda)
        if ((this.searchTerm && this.searchTerm.trim().length > 0) || this.filtroMoedaSelecionada) {
          this.aplicarFiltrosLocais();
        }

        this.loading = false;
      },
      error: (error) => {
        console.error('Error completo:', error);
        this.loading = false;
      }
    });
  }

  /** Carrega despesas usando endpoint com filtros server-side */
  private loadDespesasComFiltros(page: number, size: number): void {
    const filtros = this.montarFiltrosDTO(page, size);

    // O endpoint listarDespesasPorFiltros requer dataInicio e dataFim
    // Se nao foram fornecidos, usar data padrao (ultimo ano)
    if (!filtros.dataInicio) {
      const umAnoAtras = new Date();
      umAnoAtras.setFullYear(umAnoAtras.getFullYear() - 1);
      filtros.dataInicio = this.formatarDataFiltro(umAnoAtras);
    }
    if (!filtros.dataFim) {
      filtros.dataFim = this.formatarDataFiltro(new Date(), true);
    }

    this.despesaService.listarComFiltros(filtros).subscribe({
      next: (response) => {
        if (response && response.content) {
          // Mapear DespesaDashboardDTO para o formato que a tabela usa
          this.despesasOriginal = response.content.map((d: DespesaDashboardDTO) => ({
            id: d.id,
            observacao: d.observacao || '',
            tipoDeTransacao: d.tipoDeTransacao || 'DESPESA',
            tipoDespesa: d.tipoDespesa ? (() => {
              // O backend serializa TipoDespesa como objeto { enum, nome, cor, icone, ... }
              // via LocalizableEnumSerializer. Normalizar para garantir que seja sempre objeto.
              const td = d.tipoDespesa as TipoDespesaBackendDTO | string;
              if (typeof td === 'object') {
                return {
                  nome: td.nome || td.enum || '',
                  icone: td.icone || this.tipoDespesaMap.get(td.enum)?.icone || '',
                  cor: td.cor || this.tipoDespesaMap.get(td.enum)?.cor || '',
                };
              }
              // Caso raro: retornou como string enum (ex: "INTERNET")
              return {
                nome: td,
                icone: this.tipoDespesaMap.get(td)?.icone || '',
                cor: this.tipoDespesaMap.get(td)?.cor || '',
              };
            })() : undefined,
            cancelado: false,
            valor: this.resolverValorNaMoedaDaConta(d),
            cotacao_id: 0,
            moedaDeOrigem: this.resolverMoedaParaExibicao(d),
            valorRecebidoNaConta: d.valorRecebidoNaConta || 0,
            valorRecebidoEmGuarani: d.valorRecebidoEmGuarani || 0,
            valorRecebidoEmDolar: d.valorRecebidoEmDolar || 0,
            valorRecebidoEmReal: d.valorRecebidoEmReal || 0,
            valorRecebidoEmPeso: d.valorRecebidoEmPeso || 0,
            emissao: d.emissao ? new Date(d.emissao) : undefined,
            baixas: [],
            pessoa: d.pessoa,
            pessoa_id: d.pessoa?.id || null,
            tipo: d.tipo || 'MOVIMENTO',
          } as any));
          this.despesas = [...this.despesasOriginal];
          this.totalRecords = response.totalElements || response.content.length;
        } else {
          this.despesasOriginal = [];
          this.despesas = [];
          this.totalRecords = 0;
        }

        // Reaplicar filtros locais (busca textual + moeda)
        if ((this.searchTerm && this.searchTerm.trim().length > 0) || this.filtroMoedaSelecionada) {
          this.aplicarFiltrosLocais();
        }

        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar despesas com filtros:', error);
        console.error('Mensagem do backend:', error?.error?.message || error?.message);
        this.loading = false;
      }
    });
  }

  /** Monta o DTO de filtros a partir das propriedades do componente */
  private montarFiltrosDTO(page: number, size: number): DespesaFiltrosDTO {
    const filtros: DespesaFiltrosDTO = {
      page: page,
      size: size,
      sort: `${this.lastfield},${this.lastSort}`,
    };

    if (this.filtroObservacao && this.filtroObservacao.trim()) {
      filtros.observacao = this.filtroObservacao.trim();
    }
    if (this.filtroPessoaId != null) {
      filtros.pessoaId = this.filtroPessoaId;
    }
    if (this.filtroTipoDespesa) {
      filtros.tipoDespesa = this.filtroTipoDespesa;
    }
    if (this.filtroDataInicio) {
      filtros.dataInicio = this.formatarDataFiltro(this.filtroDataInicio);
    }
    if (this.filtroDataFim) {
      filtros.dataFim = this.formatarDataFiltro(this.filtroDataFim, true);
    }
    if (this.filtroConta != null) {
      filtros.conta = this.filtroConta;
    }

    return filtros;
  }

  /** Formata data para dd/MM/yyyyTHH:mm (formato esperado pelo backend) */
  private formatarDataFiltro(data: Date, fimDoDia: boolean = false): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = fimDoDia ? '23:59' : '00:00';
    return `${dia}/${mes}/${ano}T${horas}`;
  }

  /** Recebe o periodo selecionado pelo componente periodo-filtro e dispara busca automaticamente */
  onPeriodoDespesaChanged(periodo: PeriodoFiltro): void {
    this.periodoDespesaTexto = periodo.texto;
    this.filtroDataInicio = this.parsarDataDashboard(periodo.dataInicio);
    this.filtroDataFim = this.parsarDataDashboard(periodo.dataFim);
    // Na emissao inicial do periodo-filtro (valorPadrao), filtroConta ainda e null porque
    // autoSelecionarContaDinheiro depende de findEmpresa + loadContas. Evitamos disparar
    // uma busca "sem conta" que sera imediatamente substituida pela busca com conta.
    // Apenas guardamos as datas; autoSelecionarContaDinheiro dispara a primeira busca.
    if (!this._initialLoadDone || this.filtroConta == null) {
      return;
    }
    this.aplicarFiltros();
  }

  /** Dispara busca automaticamente ao alterar o filtro de conta no header */
  onFiltroContaChange(): void {
    // Atualizar filtroMoedaSelecionada para refletir a moeda da conta recém-selecionada.
    // moedaContaSelecionada já retorna null quando filtroConta é null,
    // e retorna o enum correto tanto para contas DINHEIRO/EFETIVO quanto para contas BANCO.
    this.filtroMoedaSelecionada = this.moedaContaSelecionada;
    this.aplicarFiltros();
  }

  /** Aplica filtros server-side */
  aplicarFiltros(): void {
    this.filtrosAtivos = true;
    this.first = 0;
    this.loadDespesas(0, this.rows);
    this.carregarTotais();
  }

  /** Limpa filtros avançados e reseta para período padrão (mês atual),
   *  mantendo o mesmo comportamento do app mobile que sempre filtra pelo mês.
   *  Nota: filtroConta e filtroMoedaSelecionada pertencem ao header inline,
   *  não ao sidebar de filtros avançados, por isso não são limpos aqui. */
  limparFiltros(): void {
    this.filtroObservacao = '';
    this.filtroPessoaId = null;
    this.filtroPessoaSelecionada = undefined;
    this.filtroTipoDespesa = null;
    this.searchTerm = '';
    this.first = 0;

    // Manter período padrão (mês atual) como o mobile faz,
    // em vez de remover datas e trocar de endpoint
    const hoje = new Date();
    this.filtroDataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0);
    this.filtroDataFim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59);
    this.filtrosAtivos = true;

    this.loadDespesas(0, this.rows);
    this.carregarTotais();
  }

  /** Filtra a tabela pela moeda clicada no card de totais.
   *  Clicar novamente no mesmo card remove o filtro (toggle).
   *  Seleciona automaticamente a conta DINHEIRO da moeda clicada e faz nova busca na API. */
  filtrarPorMoeda(moeda: string): void {
    // Bloquear clique quando conta bancaria esta ativa
    if (this.contaBancariaAtiva) {
      return;
    }

    // Se ja esta selecionada, manter o filtro (sem toggle)
    if (this.filtroMoedaSelecionada === moeda) {
      return;
    }

    // Selecionar a conta DINHEIRO da moeda clicada e fazer nova busca na API
    const contaDinheiroMoeda = this.contasFull.find(c => {
      const tipo = this.asEnumString(c.tipoConta);
      const moedaConta = this.asEnumString(c.moeda);
      return tipo !== 'BANCO' && moedaConta === moeda.toUpperCase();
    });

    if (contaDinheiroMoeda) {
      this.filtroConta = contaDinheiroMoeda.id;
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltros();
    } else {
      // Fallback: filtro local se nao encontrar conta DINHEIRO
      this.filtroMoedaSelecionada = moeda;
      this.aplicarFiltrosLocais();
    }
  }

  /** Aplica filtros locais (busca textual + moeda) sobre despesasOriginal */
  private aplicarFiltrosLocais(): void {
    let resultado = [...this.despesasOriginal];

    // Filtro por moeda — somente quando nao ha filtro de conta server-side,
    // pois o backend ja filtra por conta e a moedaDeOrigem pode diferir da conta filtrada
    if (this.filtroMoedaSelecionada && this.filtroConta == null) {
      const moedaFiltro = this.filtroMoedaSelecionada.toUpperCase();
      resultado = resultado.filter(d => {
        const moedaDespesa = this.asEnumString(d.moedaDeOrigem).toUpperCase();
        return moedaDespesa === moedaFiltro;
      });
    }

    // Filtro por busca textual
    if (this.searchTerm && this.searchTerm.trim().length > 0) {
      const termLower = this.searchTerm.trim().toLowerCase();
      resultado = resultado.filter(despesa => this.matchDespesaSearch(despesa, termLower));
    }

    this.despesas = resultado;
  }

  /** Verifica se uma despesa corresponde ao termo de busca */
  private matchDespesaSearch(despesa: any, termLower: string): boolean {
    if (this.isColumnVisible('id') && despesa.id != null) {
      if (String(despesa.id).includes(termLower)) return true;
    }
    if (this.isColumnVisible('emissao') && despesa.emissao) {
      const dataFormatada = new Date(despesa.emissao as any).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
      if (dataFormatada.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('observacao') && despesa.observacao) {
      if (despesa.observacao.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('tipoDespesa') && despesa.tipoDespesa) {
      const nome = typeof despesa.tipoDespesa === 'object' ? despesa.tipoDespesa.nome : despesa.tipoDespesa;
      if (nome && nome.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('pessoa') && despesa.pessoa?.nome) {
      if (despesa.pessoa.nome.toLowerCase().includes(termLower)) return true;
    }
    if (this.isColumnVisible('valor') && despesa.valor != null) {
      const valorFormatado = this.formatarValorMonetario(despesa.valor, despesa.moedaDeOrigem);
      if (valorFormatado.toLowerCase().includes(termLower)) return true;
    }
    return false;
  }

  /** Carrega totais por moeda */
  carregarTotais(): void {
    // Guard de boot: mesma logica do loadDespesas. Evita dispatch de /total-despesas
    // sem conta durante a inicializacao. Apos _bootLoadComplete=true, libera o fluxo.
    if (!this._bootLoadComplete && this.filtroConta == null) {
      return;
    }

    const filtros = this.montarFiltrosDTO(0, 0);

    // O endpoint de totais requer dataInicio e dataFim
    // Se nao foram fornecidos, usar data padrao (ultimo ano)
    if (!filtros.dataInicio) {
      const umAnoAtras = new Date();
      umAnoAtras.setFullYear(umAnoAtras.getFullYear() - 1);
      filtros.dataInicio = this.formatarDataFiltro(umAnoAtras);
    }
    if (!filtros.dataFim) {
      filtros.dataFim = this.formatarDataFiltro(new Date(), true);
    }

    this.loadingTotais = true;
    this.despesaService.getTotaisPorMoeda(filtros).subscribe({
      next: (response) => {
        this.totais = response;
        this.loadingTotais = false;
      },
      error: (error) => {
        console.error('Erro ao carregar totais:', error);
        this.loadingTotais = false;
      }
    });
  }

  /** Abre dialogo para selecionar formato de impressao */
  imprimirDespesa(id: number, tipo?: string): void {
    this.idParaImprimir = id;
    this.tipoParaImprimir = tipo || 'MOVIMENTO';
    this.mostrarDialogoImpressao = true;
  }

  /** Confirma impressao com o formato selecionado */
  confirmarImpressao(): void {
    if (!this.idParaImprimir) return;
    this.imprimindoId = this.idParaImprimir;

    const request$ = this.tipoParaImprimir === 'NOTA'
      ? this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.idParaImprimir}/impressao/${this.opcaoImpressao}`)
      : this.despesaService.gerarPdfMovimento(this.idParaImprimir, this.opcaoImpressao);

    request$.subscribe({
      next: (base64: string) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        this.imprimindoId = null;
        this.mostrarDialogoImpressao = false;
      },
      error: (error) => {
        console.error('Erro ao gerar PDF:', error);
        this.imprimindoId = null;
      }
    });
  }

  private setupSearchDebounce() {
    this.search$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      this.first = 0;

      if (term && term.trim().length > 0) {
        this.aplicarFiltrosLocais();
      } else {
        // Sem termo de busca, reaplicar apenas filtro de moeda se ativo
        this.aplicarFiltrosLocais();
      }
    });
  }

  /** Filtra despesas localmente buscando em todas as colunas visiveis.
   *  Delega para aplicarFiltrosLocais que combina busca textual + filtro de moeda. */
  private filtrarDespesasLocal(_term: string): void {
    this.aplicarFiltrosLocais();
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    const page = event.page;
    const size = event.rows;
    this.loadDespesas(page, size);
  }

  loadCotacao() {
    const moeda = this.form.moedaDeOrigem;
    if (moeda) {
      this.cotacaoService.getCotacaoAtual(moeda).subscribe((response) => {
        this.form.cotacao_id = response.id!;
      });
    }
  }

  onSearchChange(value: string) {
    this.searchTerm = value || '';
    this.search$.next(this.searchTerm);
  }

  customSort(event: SortEvent): void {
    if (!event.field) return;
    const field = event.field;
    const novoSort = (event.order ?? 1) === 1 ? 'asc' : 'desc';

    // Guarda contra re-emissao: ignora se campo e direcao nao mudaram
    if (field === this.lastfield && novoSort === this.lastSort) {
      return;
    }

    // Atualiza os parametros de ordenacao e dispara nova chamada a API
    // para que o sort seja aplicado sobre todos os registros, nao apenas a pagina corrente
    this.lastfield = field;
    this.lastSort = novoSort;
    this.first = 0; // volta para a primeira pagina ao reordenar
    this.loadDespesas(0, this.rows);
  }

  async submit() {
    if (this.submitting) return;
    this.isFormSubmitted = true;

    // Validar campos obrigatorios antes de abrir dialogo de pagamento
    if (!this.form.moeda) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.moeda_obrigatoria') });
      return;
    }
    if (!this.form.montante || this.form.montante <= 0) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.valor_obrigatorio') });
      return;
    }
    if (!this.form.tipoDespesa) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.tipo_obrigatorio') });
      return;
    }

    // Validar descricao - regras especiais para tipo OUTROS/OUTROS_IMPOSTOS
    const descricao = (this.form.descricao || '').trim();
    const tipoStr = this.asEnumString(this.form.tipoDespesa).toUpperCase();
    const isTipoOutros = tipoStr === 'OUTROS' || tipoStr === 'OUTROS_IMPOSTOS';

    if (isTipoOutros) {
      // Para tipo OUTROS/OUTROS_IMPOSTOS: descricao obrigatoria com minimo 10 chars
      if (!descricao) {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.descricao_obrigatoria_outros') });
        return;
      }
      if (descricao.length < 10 || descricao.length > 220) {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.descricao_tamanho_outros') });
        return;
      }
    } else if (descricao.length > 0 && (descricao.length < 3 || descricao.length > 220)) {
      // Para outros tipos: validacao padrao (3-220 chars se preenchida)
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.descricao_tamanho') });
      return;
    }

    // Validar data obrigatoria - alinhado com mobile
    if (!this.form.emissao) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('nova-despesa.messages.data_obrigatoria') });
      return;
    }

    // Sincronizar moeda do dialog com a MOEDA DO REGISTRO (form.moeda).
    // Justificativa: o usuario escolheu a moeda do gasto no formulario e
    // a matriz canonica MOEDAS_COMPATIVEIS deve ser aplicada sobre essa
    // moeda — espelha o backend (MoedaPareamentoValidator).
    //
    // Comportamento resultante por moeda do registro:
    //   - GUARANI -> cards PYG, BRL, USD, ARS (universal)
    //   - REAL    -> cards PYG, BRL, USD
    //   - DOLAR   -> cards PYG, BRL, USD
    //   - PESO    -> cards PYG, ARS
    //
    // Fallback: usa empresa.moeda caso form.moeda esteja indefinida (a
    // validacao acima impede esse cenario no fluxo normal).
    const moedaMap: Record<string, 'BRL' | 'PYG' | 'USD' | 'ARS'> = {
      'REAL': 'BRL',
      'GUARANI': 'PYG',
      'DOLAR': 'USD',
      'PESO': 'ARS',
    };
    const moedaBaseRaw = this.form.moeda ?? this.empresa?.moeda;
    const moedaBaseEnum = this.asEnumString(moedaBaseRaw);
    this.moedaPadraoISO = moedaMap[moedaBaseEnum] ?? 'BRL';

    // Sincronizar tambem a moeda da empresa (segundo filtro). O dialog
    // aplica a intersecao das duas matrizes ao decidir quais cards renderizar.
    // Ex.: registro em GUARANI + empresa em REAL -> oculta PESO.
    const moedaEmpresaEnum = this.asEnumString(this.empresa?.moeda);
    this.moedaEmpresaISO = moedaMap[moedaEmpresaEnum];

    // Garante a cotacao do dia ANTES do pagamento (solicita ao usuario se nao houver).
    const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda: this.getEmpresaMoedaPadrao() });
    if (!cotacao) {
      return;
    }
    this.carregarCotacoes();

    // Abrir dialogo de forma de pagamento
    this.mostrarDialogPagamento = true;
  }

  async onPagamentoConfirmado(result: FormaPagamentoResult): Promise<void> {
    if (this.processandoDespesa) return;
    this.processandoDespesa = true;

    try {
      await this.montaMovimento();

      // Preencher dados de pagamento conforme forma selecionada
      if (result.forma === 'dinheiro') {
        const dados = result.dados as DadosPagamentoDinheiro;
        this.movimento.valorRecebidoEmGuarani = dados.valorRecebidoEmGuarani || 0;
        this.movimento.valorRecebidoEmDolar = dados.valorRecebidoEmDolar || 0;
        this.movimento.valorRecebidoEmReal = dados.valorRecebidoEmReal || 0;
        this.movimento.valorRecebidoEmPeso = dados.valorRecebidoEmPeso || 0;
        this.movimento.valorRecebidoNaConta = 0;
      }

      if (result.forma === 'conta') {
        const dados = result.dados as DadosPagamentoConta;
        this.movimento.valorRecebidoNaConta = this.form.montante!;
        this.movimento.contaId = dados.conta_id;
        this.movimento.moedaDaConta = dados.moedaDaConta;
        this.movimento.informacaoDaTransacao = dados.informacaoDaTransacao;
        this.movimento.valorRecebidoEmGuarani = 0;
        this.movimento.valorRecebidoEmDolar = 0;
        this.movimento.valorRecebidoEmReal = 0;
        this.movimento.valorRecebidoEmPeso = 0;
      }

      // Salvar: POST para novo, PUT para edicao (alinhado com mobile)
      const isUpdate = !!this.form.id;
      const request$ = isUpdate
        ? this.despesaService.put(`/movimento/${this.form.id}`, this.movimento)
        : this.despesaService.post('/movimento', this.movimento);

      request$.subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant('common.sucesso'),
            detail: this.translate.instant('Despesa_Adicionada_com_sucesso')
          });
          this.mostrarDialogPagamento = false;
          this.limparFormulario();
          this.buildMoedaOptions();
          // Usar moeda padrao da empresa como fallback (nao hardcodar GUARANI)
          const moedaEmpresaReset = this.empresa?.moeda
            ? this.moeda.find(m => this.asEnumString(m.value) === this.asEnumString(this.empresa!.moeda)) ?? this.moeda[0]
            : this.moeda[0];
          this.form.moeda = moedaEmpresaReset;
          this.loadDespesas(0, this.rows);
          if (this.filtrosAtivos) {
            this.carregarTotais();
          }
          this.loadTranslations();
        },
      });
    } catch (error) {
      console.error('Erro ao criar despesa:', error);
    } finally {
      this.processandoDespesa = false;
    }
  }

  async montaMovimento() {

    const cotacao = await this.buscarUltimaCotacaoPorMoeda(this.getEmpresaMoedaPadrao());

    this.movimento = {
      id: this.form.id || undefined,
      codigoMovimento: null,
      observacao: this.form.descricao?.trim() || null,
      tipoDeTransacao: 'DESPESA',
      tipoDespesa: this.asEnumString(this.form.tipoDespesa) || null,
      tipoMovimento: 'ENTRADA',
      pessoaId: this.form.pessoa_id ?? null,
      valor: this.form.montante!,
      cotacaoId: cotacao.id,
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: this.form.montante!,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      valorRecebidoEmPeso: 0,
      valorTotalMoedaPadrao: this.form.montante!,
      moedaDeOrigem: this.asEnumString(this.form.moeda) || null,
      moedaDeDestino: this.asEnumString(this.form.moeda) || null,
      cancelado: false,
      emissao: toLocalISOString(this.form.emissao instanceof Date ? this.form.emissao : new Date()),
      baixas: [],
    };
  }

  /**
   * Cotacao de hoje da moeda padrao (solicitada ao usuario quando nao cadastrada).
   * Sem cotacao a operacao e abortada: nunca usa id generico.
   */
  async buscarUltimaCotacaoPorMoeda(moeda: Moeda): Promise<any> {
    const cotacao = await this.cotacaoGuard.garantirCotacao({ moeda });
    if (!cotacao) {
      throw new Error('cotacao_cancelada');
    }
    return cotacao;
  }

  private getEmpresaMoedaPadrao(): Moeda {
    const moeda = this.empresa?.moeda as MoedaDTO | undefined;
    if (moeda) {
      return this.asMoedaEnum(moeda);
    }
    return this.asMoedaEnum(this.form.moeda?.value);
  }

  private asMoedaEnum(value: any): Moeda {
    if (!value) return Moeda.REAL;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'GUARANI':
        return Moeda.GUARANI;
      case 'REAL':
        return Moeda.REAL;
      case 'DOLAR':
        return Moeda.DOLAR;
      case 'PESO':
        return Moeda.PESO;
      default:
        return Moeda.REAL;
    }
  }

  validaMoedaValor(moeda: Moeda): number {
    const valor = this.form.montante || 0;
    valor > 0 ? valor : valor * -1;

    if (moeda == Moeda.DOLAR) {
      return valor;
    } else if (moeda == Moeda.GUARANI) {
      return valor;
    }
    return valor;
  }

  private resolverValorNaMoedaDaConta(d: any): number {
    const moedaConta = this.moedaContaSelecionada?.toUpperCase();
    if (!moedaConta) return d.valor || 0;
    if (moedaConta === 'GUARANI' && d.valorRecebidoEmGuarani) return d.valorRecebidoEmGuarani;
    if (moedaConta === 'DOLAR' && d.valorRecebidoEmDolar) return d.valorRecebidoEmDolar;
    if (moedaConta === 'REAL' && d.valorRecebidoEmReal) return d.valorRecebidoEmReal;
    if (moedaConta === 'PESO' && d.valorRecebidoEmPeso) return d.valorRecebidoEmPeso;
    return d.valor || 0;
  }

  private resolverMoedaParaExibicao(d: any): any {
    const moedaConta = this.moedaContaSelecionada?.toUpperCase();
    if (!moedaConta) return d.moedaDeOrigem;
    const moedaOrigem = this.asEnumString(d.moedaDeOrigem).toUpperCase();
    if (moedaOrigem === moedaConta) return d.moedaDeOrigem;
    return moedaConta;
  }

  private asEnumString(v: any): string {
    if (!v) return '';

    if (typeof v === 'object' && 'enum' in v) {
      return String(v.enum).toUpperCase();
    }

    if (typeof v === 'string') {
      return v.toUpperCase();
    }

    if (typeof v === 'object' && 'value' in v) {
      return String(v.value).toUpperCase();
    }

    return String(v ?? '').toUpperCase();
  }

  private parseTipoDespesa(v: any): TipoDeDespesa | undefined {
    const str = this.asEnumString(v);
    if (!str) return undefined;
    const match = (Object.values(TipoDeDespesa) as unknown as string[]).find(val => String(val).toUpperCase() === str);
    return (match as unknown) as TipoDeDespesa | undefined;
  }

  /** Retorna o tipo de transacao normalizado */
  private getTipoTransacao(despesa: any): string {
    return this.asEnumString(despesa.tipoDeTransacao).toUpperCase();
  }

  /** Verifica se o tipo de despesa selecionado eh OUTROS ou OUTROS_IMPOSTOS */
  isTipoOutros(): boolean {
    const tipoStr = this.asEnumString(this.form.tipoDespesa).toUpperCase();
    return tipoStr === 'OUTROS' || tipoStr === 'OUTROS_IMPOSTOS';
  }

  /** Verifica se a despesa eh uma compra ou devolucao (tem fatura associada) */
  isNotaDespesa(despesa: any): boolean {
    const tipo = this.getTipoTransacao(despesa);
    return tipo === 'COMPRA' || tipo === 'DEVOLUCAO';
  }

  /** Verifica se a despesa eh uma transferencia */
  isTransferenciaDespesa(despesa: any): boolean {
    return this.getTipoTransacao(despesa) === 'TRANSFERENCIA';
  }

  /** Retorna o icone adequado para o botao de acao */
  getIconeAcao(despesa: any): string {
    if (this.isNotaDespesa(despesa)) return 'pi pi-file';
    return 'pi pi-pencil';
  }

  /** Retorna o tooltip adequado para o botao de acao */
  getTooltipAcao(despesa: any): string {
    if (this.isNotaDespesa(despesa)) return this.tooltips.ver_fatura;
    if (this.isTransferenciaDespesa(despesa)) return this.tooltips.ver_transferencia;
    return this.tooltips.editar;
  }

  /** Abre despesa em nova aba ou edita inline, dependendo do tipo */
  abrirDespesaNovaAba(despesa: DespesaDTO) {
    const tipo = this.getTipoTransacao(despesa);

    if (tipo === 'COMPRA' || tipo === 'DEVOLUCAO') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/notas-list/fatura', despesa.id])
      );
      window.open(url, '_blank');
    } else if (tipo === 'TRANSFERENCIA') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/nova-transferencia'], { queryParams: { editId: despesa.id } })
      );
      window.open(url, '_blank');
    } else {
      // Despesa comum: edita inline na mesma pagina.
      // Usa o endpoint GET /movimento/:id para garantir payload canonico
      // (na lista, campos como tipoDespesa vem enriquecidos como objeto { nome, icone, cor })
      if (despesa.id != null) {
        this.carregarDespesaParaEdicao(despesa.id);
      }
    }
  }

  editarDespesa(despesa: DespesaDTO) {
    const dataEmissao =
      despesa.emissao ? new Date(despesa.emissao as any) : undefined;

    this.dataSelecionada = 'outros';
    this.form.emissao = dataEmissao;

    // Atualizar label do botao "Otros" com a data real do registro
    if (dataEmissao) {
      this.outrosLabel = this.formatarDataParaExibicao(dataEmissao);
    } else {
      this.outrosLabel = this.labels.outros;
    }

    const tipoDespesaValue =
      despesa.tipoDespesa ??
      null;

    const tipoDespesaCorrespondente =
      this.tiposDespesa.find(
        t => this.asEnumString(t.value) === this.asEnumString(tipoDespesaValue)
      )?.value ?? null;

    const clienteCorrespondente = this.clientes.find(
      c => c.id === despesa.pessoa_id
    );
    const moedaReferencia =
      despesa.moedaDeOrigem ??
      (despesa as any).contaDTO?.moeda ??
      despesa.moeda;
    const moedaCorrespondente =
      this.moeda.find(
        m => this.asEnumString(m.value) === this.asEnumString(moedaReferencia)
      ) || undefined;

    this.form = {
      id: despesa.id,
      observacao: despesa.observacao,
      tipoDeTransacao: despesa.tipoDeTransacao,
      tipoDespesa: tipoDespesaCorrespondente as TipoDeDespesa | undefined,
      cancelado: despesa.cancelado,
      valor: despesa.valor,
      cotacao_id: despesa.cotacao_id,
      conta_id: despesa.conta_id,
      pessoa_id:
        clienteCorrespondente?.id ??
        despesa.pessoa?.id ??
        despesa.pessoa_id ??
        null,
      moedaDeOrigem: despesa.moedaDeOrigem,
      moeda: moedaCorrespondente,
      contaDestino_id: despesa.contaDestino_id,
      valorRecebidoNaConta: despesa.valorRecebidoNaConta,
      valorRecebidoEmGuarani: despesa.valorRecebidoEmGuarani,
      valorRecebidoEmDolar: despesa.valorRecebidoEmDolar,
      valorRecebidoEmReal: despesa.valorRecebidoEmReal,
      emissao: dataEmissao,
      baixas: despesa.baixas,
      montante: despesa.valor,
      descricao: despesa.observacao ?? ''
    };

    // Atualizar pessoaSelecionada para entity-selector
    if (clienteCorrespondente) {
      this.pessoaSelecionada = clienteCorrespondente as PessoaDTO;
    } else if (despesa.pessoa) {
      this.pessoaSelecionada = despesa.pessoa as PessoaDTO;
    } else if (despesa.pessoa_id) {
      // Busca pelo ID se nao encontrou na lista local
      this.pessoaService.get(`/pessoas/${despesa.pessoa_id}`).subscribe(
        (pessoa: any) => { this.pessoaSelecionada = pessoa; },
        () => { /* ignora erro */ }
      );
    }

    // Popular string formatada do campo de valor para exibicao correta no input
    this.montanteStr = this.formatarMontanteParaExibicao(
      despesa.valor ?? 0,
      moedaCorrespondente?.value
    );

    // Trocar para aba de cadastro com os dados preenchidos
    this.activeTabIndex = 0;

    // Atualizar titulo/subtitulo para modo edicao
    this.texts.titulo = this.translate.instant('nova-despesa.texts.titulo_editar');
    this.texts.subtitulo = this.translate.instant('nova-despesa.texts.subtitulo_editar');
  }

  /**
   * Carrega uma despesa pelo ID do movimento para edicao.
   * Chamado quando a tela recebe queryParam editId (navegacao da lista de movimentos).
   */
  private carregarDespesaParaEdicao(movimentoId: number): void {
    this.despesaService.getById(`/movimento/${movimentoId}`).subscribe({
      next: (despesa: DespesaDTO) => {
        this.editarDespesa(despesa);
      },
      error: (err) => {
        console.error('Erro ao carregar despesa para edicao:', err);
      },
    });
  }

  deletarDespesa(id: number) {
    this.deleteItemId = id;
    this.deleteDialogVisible = true;
  }

  confirmarExclusao(): void {
    if (!this.deleteItemId) return;

    this.contaService.delete(`/movimento/${this.deleteItemId}`).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('Despesa_Excluida_com_sucesso'),
        });
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
        this.loadDespesas(0, this.rows);
        if (this.filtrosAtivos) {
          this.carregarTotais();
        }
      },
      error: () => {
        this.deleteDialogVisible = false;
        this.deleteItemId = null;
      },
    });
  }

  onTabChange(event: { index: number }): void {
    // index 0 = Cadastro, index 1 = Lista
    if (event.index === 1) {
      this.texts.titulo = this.translate.instant('nova-despesa.texts.titulo_nova');
      this.texts.subtitulo = this.translate.instant('nova-despesa.texts.subtitulo_lista');
    } else {
      const isEdicao = !!this.form.id;
      this.texts.titulo = this.translate.instant(
        isEdicao ? 'nova-despesa.texts.titulo_editar' : 'nova-despesa.texts.titulo_nova'
      );
      this.texts.subtitulo = this.translate.instant(
        isEdicao ? 'nova-despesa.texts.subtitulo_editar' : 'nova-despesa.texts.subtitulo_nova'
      );
    }
  }

  novaDespesa(): void {
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.isFormSubmitted = false;
    this.pessoaSelecionada = undefined;
    this.texts.titulo = this.translate.instant('nova-despesa.texts.titulo_nova');
    this.texts.subtitulo = this.translate.instant('nova-despesa.texts.subtitulo_nova');
    this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    this.activeTabIndex = 0;
    this.cdr.detectChanges();
  }

  limparFormulario() {
    this.form = this.createEmptyForm();
    this.montanteStr = '';
    this.dataSelecionada = 'hoje';
    this.outrosLabel = this.labels.outros;
    this.definirDataHoje();
    this.isFormSubmitted = false;
    this.pessoaSelecionada = undefined;
    // Voltar titulo para modo criacao
    this.texts.titulo = this.translate.instant('nova-despesa.texts.titulo_nova');
    this.texts.subtitulo = this.translate.instant('nova-despesa.texts.subtitulo_nova');
    // Remover editId da URL
    this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    // Voltar para aba de lista
    this.activeTabIndex = 1;
    this.cdr.detectChanges();
  }

  private createEmptyForm(): DespesaDTO {
    return {
      observacao: '',
      tipoDeTransacao: TipoTransacao.DESPESA,
      tipoDespesa: undefined,
      cancelado: false,
      valor: 0,
      cotacao_id: 0,
      conta_id: null,
      pessoa_id: null,
      moedaDeOrigem: '',
      moeda: undefined,
      contaDestino_id: null,
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      emissao: undefined,
      baixas: [],
    };

  }

  private getEnumOptions(enumType: any): { label: string; value: string }[] {
    return Object.values(enumType).map((value) => ({ label: value as string, value: value as string }));
  }

  onMoedaChange(newMoeda: any): void {
    setTimeout(() => {
      this.processCurrencyChange(newMoeda);
    }, 0);
  }

  private processCurrencyChange(_newMoeda: any): void {
    // Ao trocar a moeda, limpa o campo de valor pois a formatação muda
    this.form.montante = null;
    this.montanteStr = '';
  }

  getSelectedCurrencySymbol(): string {
    if (!this.form.moeda) {
      return '';
    }

    return this.getCurrencySymbol(this.form.moeda.value);
  }

  formatarValorMonetario(valor: number, moedaDeOrigem: any): string {
    if (valor == null || isNaN(valor)) return '-';

    const moedaStr = this.asEnumString(moedaDeOrigem).toUpperCase();

    const configuracoes: Record<string, { locale: string; simbolo: string; decimais: boolean }> = {
      'GUARANI': { locale: 'es-PY', simbolo: 'Gs', decimais: false },
      'REAL': { locale: 'pt-BR', simbolo: 'R$', decimais: true },
      'DOLAR': { locale: 'en-US', simbolo: '$', decimais: true },
      'PESO': { locale: 'es-AR', simbolo: '$', decimais: true },
    };

    const config = configuracoes[moedaStr] ?? configuracoes['GUARANI'];
    const options: Intl.NumberFormatOptions = config.decimais
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 };

    const valorFormatado = new Intl.NumberFormat(config.locale, options).format(valor);
    return `${config.simbolo} ${valorFormatado}`;
  }


  private getCurrencySymbol(moeda: Moeda): string {
    switch (moeda) {
      case Moeda.REAL:
        return 'R$';
      case Moeda.DOLAR:
        return '$';
      case Moeda.GUARANI:
        return 'Gs';
      case Moeda.PESO:
        return '$';
      default:
        return '';
    }
  }

  /** Converte um valor numerico para a string formatada exibida no campo de montante */
  private formatarMontanteParaExibicao(valor: number, moeda: Moeda | undefined): string {
    if (valor == null || isNaN(valor) || valor <= 0) return '';

    if (moeda === Moeda.GUARANI) {
      const intVal = Math.round(valor);
      return intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
    } else if (moeda === Moeda.DOLAR) {
      return valor
        ? valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    } else {
      return valor
        ? valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
    }
  }

  formataCampoMontante(event?: any): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value || '';
    // Remove tudo que nao e digito
    const onlyDigits = raw.replace(/\D+/g, '');
    const moeda = this.form.moeda?.value;

    if (!onlyDigits) {
      this.form.montante = null;
      this.montanteStr = '';
      input.value = '';
      return;
    }

    if (moeda === Moeda.GUARANI) {
      // Guarani: sem centavos, apenas separador de milhar
      const intVal = parseInt(onlyDigits, 10);
      this.form.montante = intVal || null;
      const formatted = intVal
        ? intVal.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
      input.value = formatted;
      this.montanteStr = formatted;
    } else if (moeda === Moeda.DOLAR) {
      // Dolar: 2 casas decimais, formato 1,234.56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      this.form.montante = cents ? val : null;
      const formatted = cents
        ? val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      input.value = formatted;
      this.montanteStr = formatted;
    } else {
      // Real: 2 casas decimais, formato 1.234,56
      const cents = parseInt(onlyDigits, 10);
      const val = cents / 100;
      this.form.montante = cents ? val : null;
      const formatted = cents
        ? val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '';
      input.value = formatted;
      this.montanteStr = formatted;
    }
  }
}
